import { NgModule } from '@angular/core';
import { ApolloModule, APOLLO_NAMED_OPTIONS, APOLLO_OPTIONS, NamedOptions } from 'apollo-angular';
import { ApolloClientOptions, InMemoryCache, ApolloLink, defaultDataIdFromObject } from '@apollo/client/core';
import { combineLatest, filter, firstValueFrom, map, tap } from 'rxjs';
import { HttpLink } from 'apollo-angular/http';
import { setContext } from '@apollo/client/link/context';
import { Store } from '@ngrx/store';

import { environment, GQLUrl, subdomain as SUBDOMAIN } from '@env/environment';

// const uri = ''; // <-- add the URL of the GraphQL server here
// export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
//   return {
//     link: httpLink.create({uri}),
//     cache: new InMemoryCache(),
//   };
// }

export function createApollo(
	httpLink: HttpLink,
	store: Store,
	uri: string = null,
	name: string = null,
	branchSelected: number = 0,
) {
	const basic = setContext((operation, context) => ({
		headers: {
			...context.headers,
			Accept: 'charset=utf-8',
		},
	}));

	const auth = setContext((operation, context) => {
		const token = localStorage.getItem('l7_token');

		if (token === null) {
			return {};
		} else {
			return {
				headers: {
					...context.headers,
				},
			};
		}
	});

	const branchId = setContext((operation, context) => ({
		headers: {
			...context.headers,
			'X-Branch-Id': 0,
			Authorization: `Bearer ${localStorage.getItem('l7_token')}`,
			'x-subdomain': localStorage.getItem('subdomain'),
		},
	}));

	uri += uri.search('\\?') > -1 ? '&' : '?';

	const link = ApolloLink.from([basic, branchId, auth, httpLink.create({ uri })]);
	let params = {};
	if (name) {
		params['name'] = name;
	}

	return {
		...params,
		link: link,
		cache: new InMemoryCache({
			dataIdFromObject(responseObject) {
				switch (responseObject.__typename) {
					default:
						return defaultDataIdFromObject(responseObject);
				}
			},
		}),
	};
}

@NgModule({
	exports: [ApolloModule],
	providers: [
		{
			provide: APOLLO_OPTIONS,
			// useFactory: createApollo,
			useFactory(httpLink: HttpLink, store: Store) {
				const uri = `${environment.new_api_url}api/${environment.ms.sso}/graphql`;

				return createApollo(httpLink, store, uri);
			},
			deps: [HttpLink],
		},
		{
			provide: APOLLO_NAMED_OPTIONS, // <-- Different from standard initialization
			useFactory(httpLink: HttpLink, store: Store): NamedOptions {
				let options = {};

				// Add new url at this portion only

				for (let key in GQLUrl) {
					options[key] = createApollo(httpLink, store, GQLUrl[key], key);
				}

				console.info('sdasd', options);
				return options;
			},
			deps: [HttpLink, Store],
		},
	],
})
export class GraphQLModule {}
